import * as React from 'react';
import { DeliveryStatus } from '../../models/enums/delivery-status';
import { BackhaulShipmentAction, DeliveryShipmentAction } from '../../models/shipments/shipment-action';

export const CustomerDeliverShipmentTab = (props : {index : number, delivery : DeliveryShipmentAction}) => {
    return <div className={`tab-label ${ props.delivery.status === DeliveryStatus.Completed ? 'delivered' : ''}`}>
            <span className="tab-number">
                { props.index }
            </span>
            <p>
                <span>{ props.delivery.name }</span>
                { 
                    props.delivery.address && 
                    props.delivery.address.addressLine1 && 
                    props.delivery.address.addressLine1.length > 0 
                        ? <React.Fragment>
                            <span>{ props.delivery.address.addressLine1 }</span>
                            <span>
                            { 
                                `${props.delivery.address.city}, 
                                ${props.delivery.address.stateProvince} 
                                ${props.delivery.address.postalCode}` 
                            }
                            </span>
                        </React.Fragment>
                        : <span>Invalid Address</span>
                }                
            </p>
        </div>;
};

export const BackhaulShipmentTab = (props : { index: number, backhaul : BackhaulShipmentAction}) => {
    return <div className="tab-label">
                <span className="tab-number">
                    { props.index }
                </span>
                <p>
                    <span>{ props.backhaul.vendorName }</span>
                    { 
                    props.backhaul.address && 
                    props.backhaul.address.addressLine1 && 
                    props.backhaul.address.addressLine1.length > 0 
                        ? <React.Fragment>
                            <span>{ props.backhaul.address.addressLine1 }</span>
                            <span>
                            { 
                                `${props.backhaul.address.city}, 
                                ${props.backhaul.address.stateProvince} 
                                ${props.backhaul.address.postalCode}` 
                            }
                            </span>
                        </React.Fragment>
                        : <span>Invalid Address</span>
                }    
                </p>
            </div>;
};

export const OriginShipmentTab = () => {
    return <div className="tab-label">
                <span className="tab-number">
                    <i className="la la-flag"/>
                </span>
                <p><span>Route Start</span></p>
            </div>;
};

export const DestinationShipmentTab = () => {
    return <div className="tab-label">
                <span className="tab-number">
                    <i className="la la-flag-checkered"/>
                </span>
                <p><span>Route End</span></p>
            </div>;
};
